import React, { useEffect, useState } from "react";
import { getDashboardSpreadWeekdays, getDepartmentsByLocationId } from "../../services";
import { MultiBar } from "../../components";

const SpreadWeekdays = (props) => {
  const { startDate, endDate, filter, locationId } = props;
  const [data, setData] = useState();
  const [departments, setDepartments] = useState();

  useEffect(() => {
    getDepartmentsByLocationId(locationId).then((res) => {
      setDepartments(res.departments);
    });
  }, []);

  useEffect(() => {
    getDashboardSpreadWeekdays(locationId, startDate, endDate, filter).then(
      (res) => {
        setData(res);
      }
    );
  }, [startDate, endDate, filter, locationId]);

  // Only render dashboard if data is populated
  if (data) {
    // Create departmentlist for values in x-axis
    const departmentLookupList = {};
    const departmentIdList = [];
    if(departments) {
      departments.forEach((dep, i) => {
        departmentIdList.push(dep.id);
        departmentLookupList[dep.id] = dep.name;
      });
    }

    return (
      <MultiBar
        data={data.data}
        ticks={departmentIdList}
        lookup={departmentLookupList}
      />
    );
  }
  return <div></div>;
};

export default SpreadWeekdays;
